<template>
  <v-tab-item>
    <v-progress-linear v-if="loading" indeterminate />

    <v-list v-else>
      <v-list-item v-for="p in items" :key="p._id">
        <v-list-item-content>
          <v-list-item-title class="d-flex align-center">
            <a
              :href="`${linkBase}/${p._id}`"
              class="pharmacy-link"
              target="_blank"
              rel="noopener"
            >
              {{ p.name }}
            </a>

            <v-icon
              v-if="mutualIds && mutualIds.has(String(p._id))"
              color="red"
              small
              class="ml-2"
              title="Beidseitig favorisiert"
            >
              mdi-heart
            </v-icon>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="!items.length && !loading">
        <v-list-item-title class="grey--text">
          {{ emptyText }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-tab-item>
</template>

<script>
export default {
  name: "PharmacistsFavoritesTabItem",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: "Keine Einträge",
    },
    linkBase: {
      type: String,
      default: "/pharmacies",
    },
    mutualIds: {
      type: Object,
      default: () => new Set(),
    },
  },
};
</script>

<style scoped>
.pharmacy-link {
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}
.pharmacy-link:hover {
  text-decoration: underline;
}
</style>
